import { PrimaryInfo } from './../util';
import { Activity } from "../../models/Activity";

export const getSuggestion = (activity: Activity): PrimaryInfo => {
    return {
        name: activity.name + activity.purpose,
        id: activity.id
    };
};
